import { render, staticRenderFns } from "./MonetizedStoresPercentage.vue?vue&type=template&id=b0cc5e5e&"
import script from "./MonetizedStoresPercentage.vue?vue&type=script&lang=js&"
export * from "./MonetizedStoresPercentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports